import { differenceInSeconds, parseISO } from 'date-fns';
import type { SubscriptionInfo } from '../../../../api/subscription/model';
import type { OrderStatusResponse } from '~/subscription-management/api/order/model';
import type { Context } from '../../checkout.machine.types';
import { convertDateToUtc } from '~/subscription-management/utils/date.utils';

export const orderIsSuccessful = (
  context: Context,
  event: { type: 'done.invoke.getOrderStatus'; data: OrderStatusResponse },
): boolean => event.data.status === 'SUCCESSFUL' && !context.isChurning;

export const orderIsChurnAndSuccessful = (
  context: Context,
  event: { type: 'done.invoke.getOrderStatus'; data: OrderStatusResponse },
): boolean => event.data.status === 'SUCCESSFUL' && context.isChurning;

export const orderHasPaymentFailure = (
  _context: unknown,
  event: { type: 'done.invoke.getOrderStatus'; data: OrderStatusResponse },
): boolean => event.data.status === 'FAILED' && event.data.error?.errorCategory === 'PAYMENT';

export const orderHasOtherFailure = (
  _context: unknown,
  event: { type: 'done.invoke.getOrderStatus'; data: OrderStatusResponse },
): boolean => event.data.status === 'FAILED' && event.data.error?.errorCategory !== 'PAYMENT';

export const orderIsProcessing = (
  _context: unknown,
  event: { type: 'done.invoke.getOrderStatus'; data: OrderStatusResponse },
): boolean => event.data.status === 'PROCESSING';

export const orderIsProcessingTooLong = (
  _context: unknown,
  event: { type: 'done.invoke.getOrderStatus'; data: OrderStatusResponse },
): boolean =>
  event.data.status === 'PROCESSING' &&
  differenceInSeconds(convertDateToUtc(new Date()), parseISO(event.data.lastUpdated)) > 45;

export const customerHasExternalPayment = (
  _context: unknown,
  event: { type: 'done.invoke.getSubscriptionInfo'; data: SubscriptionInfo },
): boolean => event.data.customer?.paymentMethod.paymentMethodType === 'EXTERNAL_PAYMENT_METHOD';
